export default __webpack_public_path__ + "static/media/new-holland-tm-190.2023ed4a.png";